/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Speaker_Assignment_NeverInputs */

const en_options_editor_speaker_assignment_never = /** @type {(inputs: Options_Editor_Speaker_Assignment_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Never`)
};

const fr_options_editor_speaker_assignment_never = /** @type {(inputs: Options_Editor_Speaker_Assignment_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jamais`)
};

const de_options_editor_speaker_assignment_never = /** @type {(inputs: Options_Editor_Speaker_Assignment_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Niemals`)
};

const it_options_editor_speaker_assignment_never = /** @type {(inputs: Options_Editor_Speaker_Assignment_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mai`)
};

const ru_options_editor_speaker_assignment_never = /** @type {(inputs: Options_Editor_Speaker_Assignment_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Никогда`)
};

const es_options_editor_speaker_assignment_never = /** @type {(inputs: Options_Editor_Speaker_Assignment_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nunca`)
};

const zh_cn2_options_editor_speaker_assignment_never = /** @type {(inputs: Options_Editor_Speaker_Assignment_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`绝不`)
};

const ja_options_editor_speaker_assignment_never = /** @type {(inputs: Options_Editor_Speaker_Assignment_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一度もない`)
};

const hi_options_editor_speaker_assignment_never = /** @type {(inputs: Options_Editor_Speaker_Assignment_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कभी नहीं`)
};

const pt_pt2_options_editor_speaker_assignment_never = /** @type {(inputs: Options_Editor_Speaker_Assignment_NeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nunca`)
};

/**
* | output |
* | --- |
* | "Never" |
*
* @param {Options_Editor_Speaker_Assignment_NeverInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_speaker_assignment_never = /** @type {((inputs?: Options_Editor_Speaker_Assignment_NeverInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Speaker_Assignment_NeverInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_speaker_assignment_never(inputs)
	if (locale === "de") return de_options_editor_speaker_assignment_never(inputs)
	if (locale === "it") return it_options_editor_speaker_assignment_never(inputs)
	if (locale === "ru") return ru_options_editor_speaker_assignment_never(inputs)
	if (locale === "es") return es_options_editor_speaker_assignment_never(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_speaker_assignment_never(inputs)
	if (locale === "ja") return ja_options_editor_speaker_assignment_never(inputs)
	if (locale === "hi") return hi_options_editor_speaker_assignment_never(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_speaker_assignment_never(inputs)
	return en_options_editor_speaker_assignment_never(inputs)
});